import { type ProductId, availableSiteToProductName } from '../site-types';

export const toProductName = (availableSite: string) =>
  availableSiteToProductName[availableSite as ProductId];
